import { Card, BundleCardBody, Link, Text } from './styles';
import { Content, WidgetItemFranchise } from './apiService';
import { getContentUrl, useResponsiveUrl } from './utils';

const getContentHref = (c: Content | null) => (c ? getContentUrl(c) : '/');

const BundleCard = ({ video_content, english_name, persian_name, image }: WidgetItemFranchise) => {
  const imgUrl = useResponsiveUrl({ url: image?.path, desktop: 500, mobile: 250 });
  // Franchise API often omits english/persian overlay names; fall back so the link is named.
  const label = persian_name || english_name || video_content?.page_title || video_content?.title || '';

  return (
    <Card
      orientation="square"
      style={{ backgroundImage: `url(${imgUrl})` }}
      as={Link}
      href={getContentHref(video_content)}
      block
      aria-label={label || undefined}
    >
      <BundleCardBody>
        <Text variant="body2">{english_name}</Text>
        <Text variant="h2">{persian_name}</Text>
      </BundleCardBody>
    </Card>
  );
};

export default BundleCard;
